import { attach, createEvent, sample } from 'effector'
import { useUnit } from 'effector-react'
import { MenuItem } from 'react-aria-components'

import { css, cx } from '@portal/styled-system/css'

import { $portalProfile } from '@/entities/profile/portal'
import { SupportDialog } from '@/features/support-ticket'
import { useI18n } from '@/shared/lib/i18n'

import { NavbarItem } from '../navbar-item/view'
import { navbarMenu } from '../styles/recipe'
import type { NavbarItemVariant } from '../types'

const supportContactButtonClicked = createEvent()

sample({
    clock: supportContactButtonClicked,
    target: attach({
        effect: SupportDialog.model.showFx,
        source: $portalProfile,
        mapParams: (_: void, profile) => ({
            defaultNick: profile?.nick,
            defaultEmail: profile?.email,
        }),
    }),
})

export function SupportContactButton({ variant = 'default' }: { variant?: NavbarItemVariant }) {
    const { i18n } = useI18n()
    const classes = navbarMenu()

    const handleSupportContactButtonClick = useUnit(supportContactButtonClicked)

    if (variant === 'default') {
        return (
            <NavbarItem
                navbarItemType="button"
                onClick={handleSupportContactButtonClick}
                styles={css.raw({ display: { base: 'none', lg: 'flex' } })}
            >
                {i18n.PORTAL_SUPPORT}
            </NavbarItem>
        )
    }
    return (
        <MenuItem
            onAction={handleSupportContactButtonClick}
            className={cx(classes.itemNav, css({ textTransform: 'uppercase' }))}
        >
            <i className={cx('fa-light fa-comment-question', classes.icon)} />
            &nbsp;{i18n.PORTAL_SUPPORT}
        </MenuItem>
    )
}
